import { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext(null);

export const BreadcrumbProvider = ({ children }) => {
  const [firstTitles, setFirstTitles] = useState([]);
  const [secondTitle, setSecondTitle] = useState('');
  const [goBack, setGoBack] = useState(null);

  const setTitle = useCallback((first, second = '') => {
    setFirstTitles(first);
    setSecondTitle(second);
  }, []);

  // Updates only firstTitles, leaving secondTitle untouched. Used by routes
  // that don't declare a static secondTitle, so a page setting its own
  // dynamic title isn't clobbered regardless of effect ordering.
  const setFirstTitlesOnly = useCallback((first) => {
    setFirstTitles(first);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ firstTitles, secondTitle, goBack, setTitle, setFirstTitlesOnly, setGoBack }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
